<template>
  <div class="right">
    <div class="status" v-if="isEditable">
      <h2 v-translate>Promazávání zařízení podle typů</h2>
      <a
          :title="$gettext('Přidat záznam')"
          :class="['add', 'add_expand', { open: openNewItem }, { btn_inactive: false}]"
          @click.prevent="toggleNewItem()"
          v-translate>Přidat záznam
      </a>
    </div>
    <div :class="['filter', 'expand_content', { open: openNewItem }]">
      <div class="field_left">
        <p>
          <select-box
              id="devicetype"
              :required="true"
              :options="deviceTypeOptions"
              v-model="newDeviceType"
              ref="newdevicetyperef"
          >
            <translate class="translate">Typ zařízení</translate>
          </select-box>
          <text-input id="name"
                      :required="true"
                      v-model="newDeviceTypeDays"
                      ref="newdevicetypedaysref"
          >
            <translate class="translate">Počet dní neaktivity zařízení před smazáním</translate>
          </text-input>
        </p>
      </div>
      <div class="field_right field_btn">
        <p class="field">
          <input
              type="submit"
              class="btn"
              :value="'Přidat' | translate"
              @click.prevent.stop="addNewItem"
          />
        </p>
      </div>
    </div>
    <table class="vypis vypis_detail">
      <thead class="no_sortable">
      <tr>
        <th class="first_data" v-translate>Typ zařízení</th>
        <th v-translate>Počet dní neaktivity zařízení před smazáním</th>
        <th class="no_padding edit"></th>
      </tr>
      </thead>
      <tr
          v-for="item in items"
          :key="item.id"
          :ref="'devicetyperef'+item.id"
      >
        <td>{{ allDeviceTypeNames[item.id] }}</td>
        <td>{{ item.days }}</td>
        <td class="no_padding edit">
          <div class="edit_inner">
            <a
                v-if="isEditable"
                class="btn btn_action btn_delete"
                :title="'Smazat' | translate"
                @click.prevent.stop="deleteItem(item.id)">
              <translate class="translate">Smazat</translate>
            </a>
          </div>
        </td>
      </tr>
      <tr v-if="items && items.length === 0">
        <td colspan="3" v-translate>Žádné nastavené typy zařízení</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  name: 'DeleteUnusedDevicesByTypeList',
  components: {},
  mixins: [],
  created(DeviceTypeService) {
    this.deviceTypeService = DeviceTypeService

    this.deviceTypeService.getEntities({is_first_screen: 0}).then(deviceTypes => {
      this.allDeviceTypes = deviceTypes['deviceTypes']
      this.allDeviceTypeNames = []
      for (const item of this.allDeviceTypes) {
        this.allDeviceTypeNames[item.id] = item.name
      }
    });
  },
  data() {
    return {
      allDeviceTypes: [],
      allDeviceTypeNames: [],
      items: [],
      openNewItem: false,
      newDeviceType: null,
      newDeviceTypeDays: null,
    }
  },
  props: {
    isEditable: Boolean,
    value: Array,
  },
  computed: {
    deviceTypeOptions() {
      return this.allDeviceTypes
          .filter(deviceType => !this.itemIds.includes(deviceType.id))
          .map(deviceType => ({
            id: deviceType.id,
            text: deviceType.name,
          }))
    },
    itemIds() {
      return this.items.map(item => parseInt(item.id))
    },
  },
  methods: {
    toggleNewItem() {
      this.openNewItem = !this.openNewItem;
      if (this.openNewItem) {
        this.newDeviceType = null
        this.newDeviceTypeDays = null
      }
    },
    addNewItem() {
      if (this.newDeviceType) {
        this.items.push({
          id: parseInt(this.newDeviceType),
          days: parseInt(this.newDeviceTypeDays),
        })
        this.openNewItem = false
        this.newDeviceType = null
        this.newDeviceTypeDays = null
        this.$emit('input', this.items)
      }
    },
    deleteItem(deletedId) {
      this.items = this.items.filter(item => item.id !== deletedId)
      this.$emit('input', this.items)
    }
  },
  watch: {
    value(){
      this.items = this.value;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/adminConfiguration/DeleteUnusedDevicesByTypeList.vue